import { render, staticRenderFns } from "./CustomBookingStep.vue?vue&type=template&id=2ae7e0c4&scoped=true&lang=html"
import script from "./CustomBookingStep.vue?vue&type=script&lang=js"
export * from "./CustomBookingStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae7e0c4",
  null
  
)

export default component.exports